import React, { useState, useEffect,useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { RiSearchLine } from "react-icons/ri";
import { GoThumbsup } from "react-icons/go";

import emptyAgent from '../../../assets/images/emptyAgent.mp4'
import agentAvatar from '../../../assets/images/icon/agentAvatar.mp4'

import CustomSingleSelectDropdown from '../../widgets/dropdown/CustomSingleSelectDropdown';
import AgentBanner from '../../banner/agentBanner';
import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { RoleContext } from '../../pages/Userdatacontext/Datacontexts'; 
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext';
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails } from '../../slice/userSlice';
const path = "/keralaplots/";

function Agents() {

    // skelly loader
    const [isLoading, setIsLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedTown, setSelectedTown] = useState(null);
    const [townList, setTownList] = useState([]);
    

    useEffect(() => {
        setIsLoading(false);
        fetchAgentdetails();
    }, []);

    const [agentdetails,setagentdetails]=useState([]);
    const [Nodata,Setnodata]=useState('none');
    const fetchAgentdetails=async()=>{
        try {
            const response=await axios.post(`${baseURL}/fetchAgentdetails`,{
                selectedTown:selectedTown,
                selectedDistrict:selectedDistrict
            })
            console.log(response.data)
            if (response.data.length > 0) {
                setagentdetails(response.data);
                Setnodata('none')
            } else {
                setagentdetails([]); 
                Setnodata('block')
            }
        } catch (error) {
            
        }
    }
    const districtList = [
        {
            options: [
                'All',
                'Trivandrum',
                'Kollam',
                'Alleppey',
                'Pathanamthitta',
                'Kottayam',
                'Idukki',
                'Ernakulam',
                'Thrissur',
                'Palakkad',
                'Malappuram',
                'Kozhikode',
                'Wayanad',
                'Kannur',
                'Kasargod'
            ]
        }
    ];

    const handleDistrictChange = (selectedValue) => {
        const district = selectedValue?.name || selectedValue;
        //console.log("Changing district to:", district);
        //console.log("Resetting selected town...");
        setSelectedDistrict(district);
        if(district != "All"){
        setSelectedTown(null);
        fetchTownsByDistrict(district)
        }else{
            fetchTownsByDistrict('')
        }
        
        // fetchTowns(district);
    };

    const handleTownChange = (selectedValue) => {
        const town = selectedValue?.name || selectedValue;
        setSelectedTown(town);
        
        
        // fetchTowns(district);
    };

    const fetchTownsByDistrict = (district) => {
        if (!district || district === "All") {  
            setTownList([]); // Clear the town list if "All" is selected
            return;  // Stop execution
        }
    
        axios.get(`${baseURL}/get-towns/${district}`)
            .then((response) => {
                const formattedTownList = [{
                    options: response.data.map(town => town.area_name)
                }];
                setTownList(formattedTownList);  
            })
            .catch((error) => {
                console.error('Error fetching towns:', error);
            });
    };
    

    const { updateRole } = useContext(RoleContext);
    const dispatch = useDispatch();
    const handleAgentClick = async(e) => {
            e.preventDefault();
            const token = localStorage.getItem('jwtToken');
            const login_id = localStorage.getItem('login_id');
           const selectedRole='Agent';
            if (!token) {
                setIsPopupVisible(true);
                return;
            }
        else{
            try {
                const response = await axios.post(`${baseURL}/updateprofile`, {
                    login_id: login_id,
                    role_val:selectedRole,
                });

                updateRole(selectedRole);
                localStorage.setItem("roleval", selectedRole);
                dispatch(fetchUserDetails(login_id));
           }
             catch (error) {
        }
            setShowPopup(true)
        }
    };

    const handleSearch  = async(e) => {
        e.preventDefault();
        fetchAgentdetails()
    }
  return (
    <>

        {/* confirmation popup */}
        {showPopup && (
        <div className="confirmationPopup">
            <div className="confirmationPopupBox">
                <div className="confirmationPopupBoxThumbnail">
                    <video
                        playsInline
                        preload="auto"
                        autoPlay
                        muted
                        loop
                    >
                        <source src={agentAvatar} type="video/mp4" />
                    </video>
                </div>
                <div className="confirmationPopupBoxDetails">
                    <h3>Congratulations <GoThumbsup /></h3>
                    <p>Now you'r become an agent.</p>
                    <div className="confirmationPopupBtn" onClick={() => setShowPopup(false)}>Okey</div>
                </div>
            </div>
        </div>
        )}

        <section id="agentPage">
        {isLoading ? (
            <div className='SkeletonLoader'>
                <div className='SkeletonLoaderBox'>
                    <Skeleton />
                </div>
            </div>
        ) : (
            <>
                <AgentBanner />
            </>
        )}
            <div className="container">
                <div className="becomeBuilderStrip">
                    <div className="becomeBuilderStripCol1">
                        <h2 className="title">Join Us as a Real Estate Agent</h2>
                        <p>Become a part of our network and connect with property buyers and sellers. Boost your career as a trusted real estate agent today.</p>
                    </div>
                    <div className="becomeBuilderStripCol2">
                        <a href="" onClick={handleAgentClick}>Become an Agent</a>
                    </div>
                </div>
                <div className="agentPageFilterTab">
                    <div className="agentPageFilterTabBox">
                        <form action="">
                            <div className="agentPageFilterTabBoxCol1">
                                {isLoading ? (
                                    <div className='SkeletonLoader'>
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                ) : (
                                    <>
                                        <div className="formGroup">
                                            <CustomSingleSelectDropdown options={districtList} label="District"  onChange={handleDistrictChange}/>
                                        </div>
                                        <div className="formGroup">
                                            <CustomSingleSelectDropdown options={townList} label="Town" searchable={true} onChange={handleTownChange} />
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="agentPageFilterTabBoxCol2">
                                <div className="formBtnArea">
                                    <button onClick={handleSearch}><RiSearchLine /></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="agentPageList">
                {isLoading ? (
                    <div className='SkeletonLoader2'>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                        <div className='SkeletonLoaderBox'>
                            <div className="SkeletonLoaderBoxCol1">
                                <div className="SkeletonLoaderBoxCol2Logo">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2Name">
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            </div>
                            <div className="SkeletonLoaderBoxCol2">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                    {agentdetails.map((agents) => (
                        <a href={`${path}innerAgent/${agents.loginId}`} target="_blank" className="agentPageBox">
                            <div className="agentPageBoxCol1">
                                <div className="agentPageBoxThumbnail">
                                    <h4>{agents.fullname.charAt(0)}</h4>
                                </div>
                                <div className="agentPageBoxDetails">
                                    <h3 className="agentName">{agents.fullname}</h3>
                                    <div className="agentLocation">{agents.town}</div>
                                </div>
                            </div>
                            <div className="agentPageBoxCol2">
                                <ul>
                                    <li>
                                        <h4>{agents.experiance_val}</h4>
                                        <p>Experince</p>
                                    </li>
                                    <li>
                                        <h4>{agents.total_properties}</h4>
                                        <p>Properties</p>
                                    </li>
                                </ul>
                            </div>
                        </a>
                     ))}
                    </>
                )}
                <div className="emptyPage" style={{display: Nodata}}>
                  <div className="container">
                    <div className="emptyPageMain">
                      <div className="emptyPageBoxThumbnail">
                        <video
                            playsInline
                            preload="auto"
                            autoPlay
                            muted
                            loop
                        >
                            <source src={emptyAgent} type="video/mp4" />
                        </video>
                      </div>
                      <div className="emptyPageBoxDetails">
                        <h2 className="title">Agents not available</h2>
                        <p>Agents are currently unavailable to assist you. Please leave a message or check back later. We appreciate your patience and will respond as soon as possible.</p>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default Agents;
